import { UserRules } from '@uplift/types';

import { restClient } from '../../client';
import { ProviderDetail, User, UserProfile } from '../../resources';
import { Asset } from '../../resources/asset';
import { HigherEdManagerDetails, HigherEdStudentDetails } from '../higherEd';

export type AdminUsersOutput = {
  users: User[];
  providerDetails: ProviderDetail[];
  markedForNonpayment?: string[];
  higherEdManagerDetails?: HigherEdManagerDetails[];
  higherEdStudentDetails?: HigherEdStudentDetails[];
};

export type AdminSearchInput = {
  search_phrase: string;
};

export const adminUsersRequest = restClient.createRequest<null, Pick<AdminUsersOutput, 'users' | 'providerDetails'>>({
  url: '/api/v1/admin/users',
  method: 'GET',
});


export const adminUserRequest = restClient.createRequest<{
  user_id: string;
}, {
  data: {
    user: User;
    profile?: UserProfile;
    avatarAsset?: Asset;
    providerDetails?: ProviderDetail;
    rules?: UserRules;
  };
}>({
  url: '/api/v1/admin/user',
  method: 'GET',
});


export const adminSetUserActive = restClient.createRequest<{
  user_id: string;
  active: boolean;
  from_datetime?: string;
}, null>({
  url: '/api/v1/admin/set_user_active_status',
  method: 'POST',
});


export const adminSearchUsersRequest = restClient.createRequest<AdminSearchInput, AdminUsersOutput>({
  url: '/api/v1/admin/search_users_and_details',
  method: 'POST',
});

export const higherEdAdminSearchManagersRequest = restClient.createRequest<AdminSearchInput, Omit<AdminUsersOutput, 'higherEdStudentDetails'>>({
  url: '/api/v1/search/higher_ed/org_managers',
  method: 'POST',
});

export type PatchProviderMSOsAndGroupsInput = {
  mso_partner_ids?: string[];
  mso_group_ids?: string[];
};

export const patchProviderMsoAndGroups = (providerId: string, data: PatchProviderMSOsAndGroupsInput) =>
  restClient.request(`/api/v1/admin/mso/${providerId}`, {
    method: 'PATCH',
    data: data
  });
